// Modules
import xhr from 'modules/xhr';
// API
import { ENDPOINTS } from '../api.config';
// Interfaces and types
import {
  ITodoParams,
  IGetTodoRes,
  ICreateTodoBody,
  ICreateTodoRes,
  IGetEmployeeTodoBody,
  IGetEmployeeTodoRes,
  IGetTodoDetailsRes,
  IUpdateTodoRes,
  IDeleteTodoRes,
  IUpdateTodoParams,
  IShiftTodoParams,
  IUpdateTasksParams,
  ICreateTodoListBody,
  ICreateTodoListRes,
  IUpdateTodoListParams,
  ITodoListDetails,
  ITodoListDays,
  ITodoListDayParams,
  ITodoListDay,
  IFixTodoTaskParams,
  IGetTodoTodayRes,
} from 'types/todoTypes';
import { IResMessage, TQueryParams } from 'types/appTypes';

export const getTodo = (params: TQueryParams) => {
  return xhr.get<IGetTodoRes, IGetTodoRes>(`${ENDPOINTS.todo}`, { params });
};

export const createTodo = (body: ICreateTodoBody) => {
  return xhr.post<ICreateTodoRes, ICreateTodoRes>(`${ENDPOINTS.todo}`, body);
};

export const getEmployeeTodo = ({ userId, params }: IGetEmployeeTodoBody) => {
  return xhr.get<IGetEmployeeTodoRes, IGetEmployeeTodoRes>(
    `${ENDPOINTS.employees}/${userId}${ENDPOINTS.todo}`,
    { params },
  );
};

export const getTodoDetails = (id: number) => {
  return xhr.get<IGetTodoDetailsRes, IGetTodoDetailsRes>(`${ENDPOINTS.todo}/${id}`);
};

export const updateTodo = ({ id, userId, body }: IUpdateTodoParams) => {
  return xhr.patch<IUpdateTodoRes, IUpdateTodoRes>(
    `${ENDPOINTS.employees}/${userId}${ENDPOINTS.todo}/${id}`,
    body,
  );
};

export const deleteTodo = ({ id, userId }: ITodoParams) => {
  return xhr.delete<IDeleteTodoRes, IDeleteTodoRes>(
    `${ENDPOINTS.employees}/${userId}${ENDPOINTS.todo}/${id}`,
  );
};

export const deleteShiftTodo = ({ id, shiftId }: IShiftTodoParams) => {
  return xhr.delete<IDeleteTodoRes, IDeleteTodoRes>(
    `${ENDPOINTS.schedule}/${shiftId}${ENDPOINTS.todo}/${id}`,
  );
};

export const updateTasksStatus = ({ body, todoId }: IUpdateTasksParams) => {
  return xhr.patch<IUpdateTodoRes, IUpdateTodoRes>(
    `${ENDPOINTS.todo}/${todoId}${ENDPOINTS.tasks}`,
    body,
  );
};

export const createTodoList = (body: ICreateTodoListBody) => {
  return xhr.post<ICreateTodoListRes, ICreateTodoListRes>(`${ENDPOINTS.todoLists}`, body);
};

export const getTodoListDetails = (id: number) => {
  return xhr.get<ITodoListDetails, ITodoListDetails>(`${ENDPOINTS.todoLists}/${id}`);
};

export const updateTodoList = ({ id, body }: IUpdateTodoListParams) => {
  return xhr.patch<IResMessage, IResMessage>(`${ENDPOINTS.todoLists}/${id}`, body);
};

export const getTodoListDays = (id: number) => {
  return xhr.get<ITodoListDays, ITodoListDays>(
    `${ENDPOINTS.todoLists}/${id}${ENDPOINTS.todoListDays}`,
    { params: { limit: 1 } },
  );
};

export const getTodoListDay = ({ id, date }: ITodoListDayParams) => {
  return xhr.get<ITodoListDay, ITodoListDay>(
    `${ENDPOINTS.todoLists}/${id}${ENDPOINTS.todoListDays}/${date}`,
  );
};

export const fixTodoListDayTask = ({ id, date, taskId, body }: IFixTodoTaskParams) => {
  return xhr.patch<IResMessage, IResMessage>(
    `${ENDPOINTS.todoLists}/${id}${ENDPOINTS.todoListDays}/${date}${ENDPOINTS.tasks}/${taskId}`,
    body,
  );
};

export const getTodoToday = (params: TQueryParams) => {
  return xhr.get<IGetTodoTodayRes, IGetTodoTodayRes>(
    `${ENDPOINTS.todoLists}${ENDPOINTS.todoListToday}`,
    { params },
  );
};
